import { cva, cx } from '@vizit/theme';
import { Cell as AriaCell, type CellProps } from 'react-aria-components';

const cellClasses = cva({
  base: [
    'outline-none relative py-1',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-500 focus-visible:z-10',
  ],
});

/**
 * A table cell component that re-exports React Aria's Cell component with custom focus styling.
 *
 * @param props - The props for the Cell component
 * @example
 * <Cell>Cell content</Cell>
 */
function Cell(props: CellProps) {
  const { className, ...other } = props;

  return <AriaCell className={cx(cellClasses(), className)} {...other} />;
}

export { Cell };
export type { CellProps };
